import type { EditorView } from 'prosemirror-view';

import type { SchedulerLinksServiceInternal } from './scheduler-links-service-internal';

export class SchedulerLinksServicePublic {
  private preferredPickerPositions = [
    <const>{ originX: 'start', originY: 'top', overlayX: 'start', overlayY: 'bottom' },
  ];

  constructor(
    private editorView: EditorView,
    private schedulerLinksServiceInternal: SchedulerLinksServiceInternal,
  ) {}

  public schedulerLinksListOpen(origin: HTMLElement) {
    const { from, to } = this.editorView.state.selection;
    const position = origin.getBoundingClientRect();

    this.schedulerLinksServiceInternal.currentOrigin = origin;
    this.schedulerLinksServiceInternal.openSchedulerLinksDropdownList(position, {
      preferredPositions: this.preferredPickerPositions,
    });
    this.schedulerLinksServiceInternal.updateSchedulerLinksDropdownListData(from, to);
  }
}
